import { IHandoverSchema } from "../@types/handover";
import axios from "../utils/axios";

export class HandoverService {
  getAllHandoverByClinicalRecordId(patientId: any, handoverId?: number) {
    const query = typeof handoverId === 'number' ? `?handoverId=${handoverId}` : '';
    return axios.get(`/patient/${patientId}/handover${query}`);
  }
  createHandover(patientId: any, data: IHandoverSchema) {
    return axios.post(`/patient/${patientId}/handover`, data);
  }
  updateHandover(patientId: any, id: number, data: IHandoverSchema) {
    return axios.patch(`/patient/${patientId}/handover/${id}`, data);
  }
}
